function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import "jquery.cookie";
import * as React from "react";
import * as ReactDOM from "react-dom";
import * as Api from "../ajax/StatisticsApi";
import * as Utility from "../commons/Utility";
import moment from 'moment';
import IntlMessage from '../commons/Intl';
import { Label, Action, Services, Statistics, ServiceStatus } from '../commons/IntlMessages';
import ReactDatePicker from "react-datepicker";
import CustomHistorySearchDateComponent from "./CustomHistorySearchDateComponent";
var defaultLanguage = 'ja';
var intl = new IntlMessage(defaultLanguage);
var language = window.navigator.language.substring(0, 2) === 'ja' ? 'ja' : 'en';
intl.setLanguage(language);
/**
 * メインコンポーネント
 */

var MainComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(MainComponent, _React$Component);

  var _super = _createSuper(MainComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function MainComponent(props) {
    var _this;

    _classCallCheck(this, MainComponent);

    _this = _super.call(this, props);
    var now = moment();
    var searchStart = now.clone().add('month', -1);
    _this.state = {
      SearchStartDate: searchStart,
      SearchEndDate: null,
      StatisticsList: null,
      IncludeDeleted: false,
      IncludeSuspended: true,
      ErrorMessages: []
    };

    _this.onSearch();

    return _this;
  }
  /**
   * 検索結果をクリア後、検索を行います。
   */


  _createClass(MainComponent, [{
    key: "onSearchWithClear",
    value: function onSearchWithClear() {
      var _this2 = this;

      this.setState({
        StatisticsList: null
      }, function () {
        _this2.onSearch();
      });
    }
    /**
     * 検索を行います。
     */

  }, {
    key: "onSearch",
    value: function onSearch() {
      var _this3 = this;

      var startDate;

      if (this.state.SearchStartDate == null) {
        startDate = null;
      } else {
        startDate = Utility.parseMoment(this.state.SearchStartDate, 0, 0);
      }

      var endDate;

      if (this.state.SearchEndDate == null) {
        endDate = null;
      } else {
        endDate = Utility.parseMoment(this.state.SearchEndDate, 0, 0);
      }

      Api.GetStatistics(startDate, endDate, this.state.IncludeDeleted, this.state.IncludeSuspended, function (data) {
        _this3.setState({
          StatisticsList: data.StatisticsList
        });
      });
    }
    /**
     * クリアを行います。
     */

  }, {
    key: "onClear",
    value: function onClear() {
      var _this4 = this;

      this.setState({
        SearchStartDate: null,
        SearchEndDate: null,
        IncludeDeleted: false,
        IncludeSuspended: true,
        StatisticsList: null
      }, function () {
        _this4.onSearch();
      });
    }
    /**
     * 検索：開始日を更新します。
     *
     * @param d 開始日
     */

  }, {
    key: "updateSearchStartDate",
    value: function updateSearchStartDate(d) {
      this.setState({
        SearchStartDate: d
      });
    }
    /**
     * 検索：終了日を更新します。
     *
     * @param d 終了日
     */

  }, {
    key: "updateSearchEndDate",
    value: function updateSearchEndDate(d) {
      this.setState({
        SearchEndDate: d
      });
    }
    /**
     * 削除された組織を含めるか否かを更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateIncludeDeleted",
    value: function updateIncludeDeleted(e) {
      this.setState({
        IncludeDeleted: e.target.checked
      });
    }
    /**
     * 停止された組織を含めるか否かを更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateIncludeSuspended",
    value: function updateIncludeSuspended(e) {
      this.setState({
        IncludeSuspended: e.target.checked
      });
    }
    /**
     * レポートダウンロード処理を行います。
     *
     * @param selected 選択モデル
     */

  }, {
    key: "downloadReport",
    value: function downloadReport() {
      $("#Action").val("DownloadReport");
      $("#StartDate").val(this.state.SearchStartDate ? this.state.SearchStartDate.format("YYYY/MM/DD") : "");
      $("#EndDate").val(this.state.SearchEndDate ? this.state.SearchEndDate.format("YYYY/MM/DD") : "");
      $("#IncludeDeleted").val(this.state.IncludeDeleted ? "True" : "False");
      $("#IncludeSuspended").val(this.state.IncludeSuspended ? "True" : "False");
      $("#MainForm").submit();
    }
    /**
     * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.common.bind();
    }
    /**
     * ComponentがDOMツリーから削除された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {}
    /**
     * サービス状態表示名を戻します。
     *
     * @param status 状態
     */

  }, {
    key: "getServiceStatusDisplayName",
    value: function getServiceStatusDisplayName(status) {
      switch (status) {
        case 0:
          return intl.format(ServiceStatus.UnderContract);

        case 1:
          return intl.format(ServiceStatus.Deleted);

        case 2:
          return intl.format(ServiceStatus.Suspended);

        default:
          return "";
      }
    }
    /**
     * サービス種別表示名を戻します。
     *
     * @param serviceType サービス種別
     */

  }, {
    key: "getServiceTypeDisplayName",
    value: function getServiceTypeDisplayName(serviceType) {
      switch (serviceType) {
        case 0:
          return intl.format(Services.Enterprise);

        case 1:
          return intl.format(Services.Starter);

        default:
          return "";
      }
    }
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      return /*#__PURE__*/React.createElement("div", {
        className: "content-container"
      }, /*#__PURE__*/React.createElement("div", {
        id: "overlay"
      }, /*#__PURE__*/React.createElement("div", {
        className: "cv-spinner"
      }, /*#__PURE__*/React.createElement("span", {
        className: "spinner"
      }))), /*#__PURE__*/React.createElement("main", {
        className: "main newdesign"
      }, /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: "Action",
        id: "Action",
        value: ""
      }), /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: "StartDate",
        id: "StartDate",
        value: ""
      }), /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: "EndDate",
        id: "EndDate",
        value: ""
      }), /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: "IncludeDeleted",
        id: "IncludeDeleted",
        value: ""
      }), /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: "IncludeSuspended",
        id: "IncludeSuspended",
        value: ""
      }), /*#__PURE__*/React.createElement("div", {
        className: "main__wrapper"
      }, /*#__PURE__*/React.createElement("div", {
        className: "menu",
        id: "menuCont"
      }, /*#__PURE__*/React.createElement("div", {
        className: "menu__title"
      }, intl.format(Statistics.Title)), /*#__PURE__*/React.createElement("div", {
        className: "menu__wrapper"
      }, /*#__PURE__*/React.createElement("div", {
        className: "time"
      }, /*#__PURE__*/React.createElement("div", {
        className: "time__title"
      }, intl.format(Statistics.TimeAndDate)), /*#__PURE__*/React.createElement("div", {
        className: "time__cont"
      }, /*#__PURE__*/React.createElement("div", {
        className: "time__contTitle"
      }, intl.format(Label.SearchStartDate)), /*#__PURE__*/React.createElement(ReactDatePicker, {
        customInput: /*#__PURE__*/React.createElement(CustomHistorySearchDateComponent, null),
        name: "SearchStartDate",
        id: "SearchStartDate",
        selected: this.state.SearchStartDate,
        onChange: this.updateSearchStartDate.bind(this),
        dateFormat: "YYYY/M/D",
        locale: "ja",
        showMonthDropdown: true,
        showYearDropdown: true,
        dropdownMode: "select"
      })), /*#__PURE__*/React.createElement("div", {
        className: "time__cont"
      }, /*#__PURE__*/React.createElement("div", {
        className: "time__contTitle"
      }, intl.format(Label.SearchEndDate)), /*#__PURE__*/React.createElement(ReactDatePicker, {
        customInput: /*#__PURE__*/React.createElement(CustomHistorySearchDateComponent, null),
        name: "SearchEndDate",
        id: "SearchEndDate",
        selected: this.state.SearchEndDate,
        onChange: this.updateSearchEndDate.bind(this),
        dateFormat: "YYYY/M/D",
        locale: "ja",
        showMonthDropdown: true,
        showYearDropdown: true,
        dropdownMode: "select"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "options"
      }, /*#__PURE__*/React.createElement("div", {
        className: "options__title"
      }, intl.format(Statistics.Options)), /*#__PURE__*/React.createElement("div", {
        className: "options__cont"
      }, /*#__PURE__*/React.createElement("div", {
        className: "checkbox icheck-asbestos"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "useState"
      }, intl.format(Statistics.IncludeDeleted)), /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        id: "useState",
        name: "useState",
        onChange: this.updateIncludeDeleted.bind(this),
        checked: this.state.IncludeDeleted
      }))), /*#__PURE__*/React.createElement("div", {
        className: "options__cont"
      }, /*#__PURE__*/React.createElement("div", {
        className: "checkbox icheck-asbestos"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "useState"
      }, intl.format(Statistics.IncludeSuspended)), /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        id: "useState",
        name: "useState",
        onChange: this.updateIncludeSuspended.bind(this),
        checked: this.state.IncludeSuspended
      })))), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "menu__btn imgAndTextBtn",
        onClick: this.onSearchWithClear.bind(this)
      }, /*#__PURE__*/React.createElement("div", {
        className: "menu__btnImg imgAndTextBtn__btnImg"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_Search.svg"
      })), /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnText"
      }, intl.format(Action.ConditionSearch))), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "menu__btn imgAndTextBtn",
        onClick: this.downloadReport.bind(this)
      }, /*#__PURE__*/React.createElement("div", {
        className: "menu__btnImg imgAndTextBtn__btnImg"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_Download-1.svg"
      })), /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnText"
      }, intl.format(Action.ConditionReport))), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "menu__btn menu__btn--white imgAndTextBtn",
        onClick: this.onClear.bind(this)
      }, /*#__PURE__*/React.createElement("div", {
        className: "menu__btnImg imgAndTextBtn__btnImg"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_Cancel.svg"
      })), /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnText"
      }, intl.format(Action.Clear))))), /*#__PURE__*/React.createElement("div", {
        className: "mainContent"
      }, /*#__PURE__*/React.createElement("div", {
        id: "statistics",
        className: "table-responsive"
      }, /*#__PURE__*/React.createElement("table", {
        className: "table table-sm table-hover table-striped"
      }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, "\u7D44\u7E54\u540D"), /*#__PURE__*/React.createElement("td", null, "\u30B5\u30FC\u30D3\u30B9\u72B6\u614B"), /*#__PURE__*/React.createElement("td", null, "\u30B5\u30FC\u30D3\u30B9\u7A2E\u5225"), /*#__PURE__*/React.createElement("td", {
        style: {
          textAlign: "right"
        }
      }, "\u30E6\u30FC\u30B6\u30FC\u6570"), /*#__PURE__*/React.createElement("td", {
        style: {
          textAlign: "right"
        }
      }, "\u30B2\u30B9\u30C8\u6570"), /*#__PURE__*/React.createElement("td", {
        style: {
          textAlign: "right"
        }
      }, "\u30A2\u30AF\u30C6\u30A3\u30D6", /*#__PURE__*/React.createElement("br", null), "\u30E6\u30FC\u30B6\u30FC\u6570"), /*#__PURE__*/React.createElement("td", {
        style: {
          textAlign: "right"
        }
      }, "\u30EB\u30FC\u30E0", /*#__PURE__*/React.createElement("br", null), "\u958B\u50AC"), /*#__PURE__*/React.createElement("td", {
        style: {
          textAlign: "right"
        }
      }, "\u30EB\u30FC\u30E0", /*#__PURE__*/React.createElement("br", null), "\u4F5C\u6210"), /*#__PURE__*/React.createElement("td", {
        style: {
          textAlign: "right"
        }
      }, "\u30EB\u30FC\u30E0", /*#__PURE__*/React.createElement("br", null), "\u8907\u88FD"), /*#__PURE__*/React.createElement("td", {
        style: {
          textAlign: "right"
        }
      }, "\u30EB\u30FC\u30E0", /*#__PURE__*/React.createElement("br", null), "\u524A\u9664"), /*#__PURE__*/React.createElement("td", {
        style: {
          textAlign: "right"
        }
      }, "\u30EB\u30FC\u30E0", /*#__PURE__*/React.createElement("br", null), "\u4FDD\u5B58"), /*#__PURE__*/React.createElement("td", {
        style: {
          textAlign: "right"
        }
      }, "\u30EB\u30FC\u30E0", /*#__PURE__*/React.createElement("br", null), "\u5FA9\u5143"), /*#__PURE__*/React.createElement("td", {
        style: {
          textAlign: "right"
        }
      }, "\u7D20\u6750", /*#__PURE__*/React.createElement("br", null), "\uFF35\uFF30"), /*#__PURE__*/React.createElement("td", {
        style: {
          textAlign: "right"
        }
      }, "\u7D20\u6750", /*#__PURE__*/React.createElement("br", null), "\u8907\u88FD"), /*#__PURE__*/React.createElement("td", {
        style: {
          textAlign: "right"
        }
      }, "\u7D20\u6750", /*#__PURE__*/React.createElement("br", null), "\u524A\u9664"), /*#__PURE__*/React.createElement("td", {
        style: {
          textAlign: "right"
        }
      }, "\u7D20\u6750", /*#__PURE__*/React.createElement("br", null), "\uFF24\uFF2C"), /*#__PURE__*/React.createElement("td", {
        style: {
          textAlign: "right"
        }
      }, "\u30E1\u30F3\u30D0\u30FC", /*#__PURE__*/React.createElement("br", null), "\u62DB\u5F85"), /*#__PURE__*/React.createElement("td", {
        style: {
          textAlign: "right"
        }
      }, "\u30E1\u30F3\u30D0\u30FC", /*#__PURE__*/React.createElement("br", null), "\u524A\u9664"), /*#__PURE__*/React.createElement("td", {
        style: {
          textAlign: "right"
        }
      }, "\u30E1\u30F3\u30D0\u30FC", /*#__PURE__*/React.createElement("br", null), "\u53C2\u52A0"), /*#__PURE__*/React.createElement("td", {
        style: {
          textAlign: "right"
        }
      }, "\u30E1\u30F3\u30D0\u30FC", /*#__PURE__*/React.createElement("br", null), "\u9000\u51FA"), /*#__PURE__*/React.createElement("td", {
        style: {
          textAlign: "right"
        }
      }, "\u30AD\u30E3\u30D7\u30C1\u30E3"), /*#__PURE__*/React.createElement("td", {
        style: {
          textAlign: "right"
        }
      }, "\u30D6\u30ED\u30FC\u30C9", /*#__PURE__*/React.createElement("br", null), "\u30AD\u30E3\u30B9\u30C8"))), /*#__PURE__*/React.createElement("tbody", null, this.state.StatisticsList && this.state.StatisticsList.map(function (x, _i) {
        return /*#__PURE__*/React.createElement("tr", {
          key: x.OrganizationId
        }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", null, x.OrganizationName, ")")), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", null, _this5.getServiceStatusDisplayName(x.Deleted))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", null, _this5.getServiceTypeDisplayName(x.ServiceType))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          style: {
            textAlign: "right"
          }
        }, x.UserCount, "(", x.UserMaxCount.toLocaleString(), ")")), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          style: {
            textAlign: "right"
          }
        }, x.GuestCount, "(", x.GuestMaxCount.toLocaleString(), ")")), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          style: {
            textAlign: "right"
          }
        }, x.ActiveUserCount.toLocaleString(), "(", (x.UserCount + x.GuestCount).toLocaleString(), ")")), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          style: {
            textAlign: "right"
          }
        }, x.SessionCount.toLocaleString())), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          style: {
            textAlign: "right"
          }
        }, x.CreatedSessionCount.toLocaleString())), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          style: {
            textAlign: "right"
          }
        }, x.CopiedSessionCount.toLocaleString())), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          style: {
            textAlign: "right"
          }
        }, x.DeletedSessionCount.toLocaleString())), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          style: {
            textAlign: "right"
          }
        }, x.SavedSessionCount.toLocaleString())), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          style: {
            textAlign: "right"
          }
        }, x.LoadedSessionCount.toLocaleString())), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          style: {
            textAlign: "right"
          }
        }, x.UploadedMaterialCount.toLocaleString())), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          style: {
            textAlign: "right"
          }
        }, x.CopiedMaterialCount.toLocaleString())), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          style: {
            textAlign: "right"
          }
        }, x.DeletedMaterialCount.toLocaleString())), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          style: {
            textAlign: "right"
          }
        }, x.DownloadedMaterialCount.toLocaleString())), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          style: {
            textAlign: "right"
          }
        }, x.AddedMemberCount.toLocaleString())), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          style: {
            textAlign: "right"
          }
        }, x.DeletedMemberCount.toLocaleString())), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          style: {
            textAlign: "right"
          }
        }, x.JoinedMemberCount.toLocaleString())), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          style: {
            textAlign: "right"
          }
        }, x.ExitedMemberCount.toLocaleString())), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          style: {
            textAlign: "right"
          }
        }, x.TakedCaptureCount.toLocaleString())), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          style: {
            textAlign: "right"
          }
        }, x.StartBroadcastCount.toLocaleString())));
      }))))))));
    }
  }]);

  return MainComponent;
}(React.Component);
/**
 * レンダラー
 *
 * @param el バインド対象
 * @param common 共通
 */


export default function (el, common) {
  ReactDOM.render( /*#__PURE__*/React.createElement(MainComponent, {
    common: common
  }), el);
}